// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"f9cb6150","41":"c1cb86b1","304":"c9ef10eb","489":"a3b07c9f","615":"bfd45b66","709":"0b69ac86","754":"e84e9660","764":"374ee42c"}[chunkId] + ".chunk.js";
};